// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import safeFetch from "@/lib/helpers/safe-fetch"

// components
import { ShowRowContent } from "@/lib/types/api/show-data";

export async function sendRecommendationPutEvent(showId: string, recommendationId: string) {
  const searchParams = new URLSearchParams();
  searchParams.append('showId', showId);
  searchParams.append('recommendationId', recommendationId);

  const response = await safeFetch(
    `/api/rec-engine/?${searchParams.toString()}`,
    { 
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    }
  )

  return response.ok
}

export async function handleRecommendedShowClick(show: ShowRowContent) {
  const showId = show.cid;
  const recommendationId = show?.recommendation_id;
  if(!recommendationId) {
    console.error('No recommendationId found for show:', showId);
    return;
  }
  sendRecommendationPutEvent(showId, recommendationId);
};